module.exports = BMAP_MAPTYPE_CONTROL_MAP;